<template>
  <div
    class="chapter"
    v-loading="webLoading2"
    element-loading-text="数据正在解析中。。。"
  >
    <el-container>
      <el-aside
        width="240px"
        style="
          padding-right: 10px;
          overflow: auto;
          background: #fff;
          border-radius: 4px;
        "
      >
        <div class="title-add">
          <div style="margin-left: 10px">课程</div>
        </div>
        <tree
          :showAdd="String(2)"
          v-on:setId="changeId"
          v-on:setcourseId="changeCourseId"
        ></tree>
      </el-aside>
      <el-main style="margin-top: -20px; padding-bottom: 0px">
        <el-card class="box-card" style="margin-top: 0px">
          <el-row :span="12">
            <el-col :sm="24" :md="24" :lg="24">
              <div
                style="
                  float: right;
                  margin-bottom: 20px;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <el-upload
                  v-auth="'/chapter/upload'"
                  class="upload-demo"
                  :action="fileObj.url2+'?subjectId='+id"
                  :data="fileLoadData"
                  :before-upload="fileBeforeFileUpload"
                  :on-success="fileLoadSuccess"
                  :on-progress="fileFprogress"
                  :on-error="fileError"
                  :headers="reqData"
                  :show-file-list="false"
                >
                  <el-button size="small" type="primary"
                    >章节试题批量导入</el-button
                  >
                </el-upload>
                <el-button
                  v-auth="'/chapter/downloadFile'"
                  @click="downloadFile"
                  style="margin-left: 10px"
                  size="small"
                  type="primary"
                  >模板下载</el-button
                >
                <el-button
                  v-auth="'/chapter/copyMore'"
                  @click="copyDialog = true"
                  style="margin-left: 10px"
                  size="small"
                  type="primary"
                  :disabled="
                    page.rows.length != 0 || copyForm.courseIdByNew == ''
                  "
                  >批量复制</el-button
                >
              </div>
            </el-col>
          </el-row>
          <!-- <el-row :span="24">
            <el-col :span="12">
              <el-button type="primary" icon="el-icon-plus">新增</el-button>
              <el-button type="danger" @click="batchDeleteChapter" icon="el-icon-minus">批量删除</el-button>
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
              <el-button
                style="text-align: right"
                type="primary"
                @click="exportExcel"
                :loading="loading"
                icon="el-icon-upload2"
              >导出</el-button>
            </el-col>
          </el-row>-->
          <el-table
            v-loading="webLoading"
            element-loading-text="数据正在加载中。。。"
            ref="multipleTable"
            :data="page.rows"
            tooltip-effect="dark"
            style="margin-top: 0px; width: 100%"
            border
            row-key="id"
            @selection-change="selectionChange"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column
              prop="name"
              label="章节名称"
              show-overflow-tooltip
              width="360"
            >
              <template slot-scope="scope">
                <!-- <div class="name-algin"> -->
                <i
                  v-if="scope.row.state == 1"
                  class="iconfont iconeye operItem"
                ></i>
                <i
                  v-if="scope.row.state == -1"
                  class="iconfont iconeye-slash hei"
                ></i>
                <!-- <span v-if="scope.row.children" class="re">[最新]</span>
                <span v-if="scope.row.children" class="hei">[普通]</span>-->
                <span
                  v-if="scope.row.pay == -1 && scope.row.pid == 0"
                  class="gr"
                  >[免费]</span
                >
                <span v-if="scope.row.pay == 1 && scope.row.pid == 0" class="re"
                  >[付费]</span
                >
                <span class="operItem">{{ scope.row.name }}</span>
                <!-- <i v-if="scope.row.children" class="iconfont iconxunhuan operItem"></i> -->

                <i
                  v-if="scope.row.children"
                  v-auth="'/chapter/addChapter'"
                  class="iconfont iconicon-test operItem"
                  @click="
                    getChapterList(scope.row)
                    addForm.pid = scope.row.id
                  "
                  title="添加章节"
                ></i>
                <!-- </div> -->
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="knowledgeNum"
              label="考点"
            >
              <template slot-scope="scope">
                <span
                  v-if="!scope.row.children"
                  @click="openknowledgeVisible(scope.row.id)"
                  class="mainColor"
                  >{{ scope.row.knowledgeNum || 0 }}</span
                >
              </template>
            </el-table-column>

            <el-table-column prop="state" show-overflow-tooltip label="附件">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.attachmentName"
                  class="mainColor"
                  @click="
                    addFileVisible = true
                    addFile.id = scope.row.id
                    addFile.attachmentName = scope.row.attachmentName
                    addFile.attachment = scope.row.attachment
                  "
                  >{{ scope.row.attachmentName }}</span
                >
                <!-- <i v-if="scope.row.attachmentName" class="iconfont iconbianji operItem"></i> -->
                <i
                  v-if="!scope.row.attachmentName && !scope.row.children"
                  @click="
                    addFileVisible = true
                    addFile.id = scope.row.id
                  "
                  class="iconfont iconicon-test operItem"
                ></i>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="state" label="试题">
              <template slot-scope="scope">
                <span
                  v-if="!scope.row.children"
                  @click="goQuestion(scope.row.id)"
                  class="mainColor"
                  >{{ scope.row.questionNum || 0 }}</span
                >
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="state" label="视频">
              <template slot-scope="scope">
                <!-- <i
                  v-if="!scope.row.children"
                  @click="openVideo(scope.row)"
                  class="iconfont iconicon-test operItem"videoNum
                ></i>-->
                <!-- <div v-if="!scope.row.children" class="add-button" @click="openVideo(scope.row)">查看</div> -->
                <span
                  v-if="!scope.row.children"
                  @click="openVideo(scope.row)"
                  class="mainColor"
                  >{{ scope.row.videoNum || 0 }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="remark"
              label="备注"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop
              label="操作"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <div class="operationGroups">
                  <span
                    v-if="scope.row.children"
                    v-auth="'/chapter/updateChapter'"
                    @click="
                      editForm = scope.row
                      editFormVisible = true
                      addState = 1
                    "
                  >
                    <i class="iconfont iconbianji mainColor" title="编辑"></i>
                  </span>
                  <span
                    v-else
                    v-auth="'/chapter/updateChapter'"
                    @click="
                      getChapterList2(scope.row)
                      editForm = scope.row
                      editFormVisible = true
                      addState = 2
                    "
                  >
                    <i class="iconfont iconbianji mainColor" title="编辑"></i>
                  </span>
                  <!-- <span @click="deleteChapter(scope.row)">
                    <i class="iconfont iconshanchu mainColor" title="删除"></i>
                  </span>-->
                  <span
                    v-if="!scope.row.children"
                    v-auth="'/chapter/import'"
                    @click="
                      importVisible = true
                      chapterId = scope.row.id
                    "
                  >
                    <i class="iconfont icondaoru1 mainColor" title="导入"></i>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="!webLoading"
            background
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog
      title="添加章节"
      :visible.sync="addFormVisible"
      width="400px"
      left
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <!-- <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="具体课程" prop="courseId" v-if="addState==1">
            <el-cascader
              clearable
              :show-all-levels="false"
              v-model="addForm.courseId"
              :props="subjectTreeProps"
              placeholder="请输入具体课程"
              :options="subjectTreeList"
              @change="subjectChange"
            ></el-cascader>
          </el-form-item>
        </el-col>-->
        <el-row :span="12"></el-row>
        <el-row :span="12"></el-row>
        <el-row :span="12"></el-row>

        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 2">
          <el-form-item label="所属章节" prop="pid">
            <el-select
              style="width: 100%"
              clearable
              v-model="addForm.pid"
              placeholder="请输入所属章节"
            >
              <el-option
                v-for="item in chapterList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="章节名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入章节名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="排序" prop="sort">
            <el-input
              type="number"
              v-model="addForm.sort"
              placeholder="请输入排序"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="是否启用" prop="state">
            <el-radio-group v-model="addForm.state">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="-1">下架</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 1">
          <el-form-item label="是否付费" prop="pay">
            <div style="white-space: nowrap">
              <el-radio-group v-model="addForm.pay">
                <el-radio :label="1">付费</el-radio>
                <el-radio :label="-1">免费</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 1">
          <el-form-item label="价格" prop="price">
            <el-input
              type="number"
              :disabled="addForm.pay == 1 ? false : true"
              v-model="addForm.price"
              placeholder="请输入价格"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 2">
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              v-model="addForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button v-auth="'/chapter/addChapter'" type="primary" @click="addChapter">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑章节"
      :visible.sync="editFormVisible"
      width="400px"
      left
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="具体课程" prop="courseId" v-if="addState == 1">
            <el-cascader
              clearable
              :show-all-levels="false"
              style="width: 100%"
              v-model="editForm.courseId"
              :props="subjectTreeProps"
              placeholder="请输入具体课程"
              :options="subjectTreeList"
              @change="subjectChange"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 2">
          <el-form-item label="所属章节" prop="pid">
            <el-select
              style="width: 100%"
              clearable
              v-model="editForm.pid"
              placeholder="请输入所属章节"
            >
              <el-option
                v-for="item in chapterList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="章节名称" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入章节名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="排序" prop="sort">
            <el-input
              type="number"
              v-model="editForm.sort"
              placeholder="请输入排序"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="是否启用" prop="state">
            <el-radio-group v-model="editForm.state">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="-1">下架</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 1">
          <el-form-item label="是否付费" prop="pay">
            <div style="white-space: nowrap">
              <el-radio-group v-model="editForm.pay">
                <el-radio :label="1">付费</el-radio>
                <el-radio :label="-1">免费</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 1">
          <el-form-item label="价格" prop="price">
            <el-input
              type="number"
              :disabled="editForm.pay == 1 ? false : true"
              v-model="editForm.price"
              placeholder="请输入价格"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" v-if="addState == 2">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="editForm.remark"
              type="textarea"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateChapter">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传xls、xlsx文件，且不超过1024kb
        </div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="章节名称"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="state" label></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="视频" :visible.sync="addVideoVisible" width="60%" left>
      <div class="view-video">
        <div class="view-item">
          <span>视频课程:&nbsp;&nbsp;&nbsp;</span>
          <el-select
            v-model="valueData"
            clearable
            @change="listChange"
            placeholder="请选择视频课程"
          >
            <el-option
              v-for="item in videoList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="view-item" style="margin-left: 20px">
          <span>具体视频:&nbsp;&nbsp;&nbsp;</span>
          <el-select
            v-model="valueData1"
            multiple
            collapse-tags
            clearable
            @change="addlistChange"
            placeholder="请选择具体视频"
          >
            <el-option
              v-for="item in addvideoList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <el-button
          v-auth="'/chapter/addConcat'"
          size="small"
          style="margin-left: 20px"
          @click="addConcat"
          type="primary"
        >
          <!-- <i class="iconfont icondown" style="margin-top:2px;"></i> -->
          添加绑定
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="videoRows"
        v-loading="webLoading1"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column prop="name" label="视频名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              @click="
                playerOptions.sources[0].src = scope.row.url
                videoDialog = true
              "
              class="mainColor"
              >{{ scope.row.name }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="url"
          label="播放"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <i
              class="iconfont iconziyuan mainColor"
              @click="
                playerOptions.sources[0].src = scope.row.url
                videoDialog = true
              "
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="操作" width="120">
          <template slot-scope="scope">
            <span v-auth="'/chapter/deleteVideo'" class="mainColor" @click="deleteVideo(scope.row.id)"
              >解除绑定</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          v-auth="'/chapter/updateChapterVideo'"
          type="primary"
          @click="updateChapterVideo"
          icon="el-icon-document"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importVisible" width="80%" left>
      <Import :value="chapterId" v-on:showDiolog="showmessahe"></Import>
    </el-dialog>
    <el-dialog title="附件" :visible.sync="addFileVisible" width="60%" left>
      <el-form
        ref="addFileForm"
        :model="addFile"
        :rules="addFileRules"
        :label-width="formLabelWidth"
      >
        <el-col :sm="24" :md="12" :lg="10">
          <el-form-item label="文件名称" prop="attachmentName">
            <el-input
              v-model="addFile.attachmentName"
              placeholder="请输入文件名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="24">
          <el-form-item prop="attachment">
            <div class="view-file">
              <el-upload
                v-auth　="'/chapter/chapterAttachment'"
                class="upload-demo"
                :action="fileObj.url"
                :data="fileLoadData"
                :before-upload="fileBeforeImgUpload"
                :on-success="fileHandleSuccess"
                :headers="reqData"
                :show-file-list="true"
              >
                <el-button size="small" type="primary">上传附件</el-button>
              </el-upload>
              <div class="aaaaa" v-auth　="'/chapter/chapterAttachment'">
                <el-button
                  style="margin-left: 10px"
                  size="small"
                  :disabled="downType"
                  @click="DownLoadFile"
                  type="primary"
                  >下载附件</el-button
                >
                <span style="margin-left: 10px; color: #a2aabc"
                  >常规文档格式，不过超10M</span
                >
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFileVisible = false">取 消</el-button>
        <el-button type="primary" @click="chapterAttachment" v-auth　="'/chapter/chapterAttachment'">确 定</el-button>
      </div>
      <!-- <div class="view-file">
        <el-upload
          class="upload-demo"
          :action="fileObj.url"
          :data="fileLoadData"
          :before-upload="fileBeforeImgUpload"
          :on-success="fileHandleSuccess"
          :headers="reqData"
          :show-file-list="false"
        >
          <el-button size="small" type="primary">上传附件</el-button>
        </el-upload>
        <span style="margin-left:10px;color:#A2AABC">常规文档格式，不过超10M</span>
      </div>-->
      <!-- <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="state" label="状态" show-overflow-tooltip></el-table-column>

        <el-table-column prop="courseId" label="所属科目" show-overflow-tooltip></el-table-column>
        <el-table-column prop="questionTypeId" label="试题题型" show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" label="标题题干" show-overflow-tooltip></el-table-column>
        <el-table-column prop="answer" label="试题答案" show-overflow-tooltip></el-table-column>
      </el-table>-->
    </el-dialog>
    <el-dialog
      title="预览视频"
      :visible.sync="videoDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </el-dialog>
    <el-dialog
      title="考点"
      :visible.sync="knowledgeVisible"
      class="knowledgeVisible"
    >
      <el-button
        v-auth="'/chapter/addChapterKnowledge'"
        size="small"
        style="float: right; margin-bottom: 20px"
        type="primary"
        @click="openknowledgeAddVisible"
        >添加考点</el-button
      >
      <el-table
        v-loading="knowledgeLoading"
        element-loading-text="数据正在加载中。。。"
        :data="knowledgeList"
        tooltip-effect="dark"
        style="margin-top: 0px; width: 100%"
        border
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->

        <el-table-column
          width="300"
          show-overflow-tooltip
          prop="name"
          label="考点名称"
        ></el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="rate"
          label="考频"
        ></el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="hard"
          label="难度"
        ></el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="sort"
          label="排序"
        ></el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="questionNum"
          label="试题数量"
        >
          <template slot-scope="scope">
            <span
              v-if="!scope.row.children"
              @click="goExamView(scope.row)"
              class="mainColor"
              >{{ scope.row.questionNum || 0 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop
          label="操作"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <div class="operationGroupsx">
              <span v-auth="'/chapter/editChapterKnowledge '">
                <i
                  class="iconfont iconbianji mainColor"
                  @click="openknowledgeAddVisible(scope.row)"
                  title="编辑"
                ></i>
              </span>

              <span>
                <i
                  class="iconfont iconshanchu mainColor"
                  @click="deleteChapterKnowledge(scope.row.id)"
                  title="删除"
                ></i>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="knowledgeForm.id ? '编辑考点' : '添加考点'"
      :visible.sync="knowledgeAddVisible"
      width="400px"
    >
      <el-form
        ref="knowledgeForm"
        :model="knowledgeForm"
        :label-width="formLabelWidth"
        :rules="knowledgeFormRules"
      >
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="考点名称" prop="name">
            <el-input
              v-model="knowledgeForm.name"
              placeholder="请输入考点名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="考频" prop="rate">
            <el-rate
              v-model="knowledgeForm.rate"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
            ></el-rate>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="难度" prop="hard">
            <el-rate
              v-model="knowledgeForm.hard"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
            ></el-rate>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="排序" prop="sort">
            <el-input
              type="number"
              v-model="knowledgeForm.sort"
              placeholder="请输入排序"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" v-if="knowledgeForm.id">
          <el-form-item label="试题数量" prop="questionNum">
            <el-input
              :disabled="knowledgeForm.id ? true : false"
              type="number"
              v-model="knowledgeForm.questionNum"
              placeholder="请输入试题数量"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="knowledgeAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="addChapterKnowledge">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 复制更多 -->
    <el-dialog title="批量复制" :visible.sync="copyDialog" width="500px">
      <el-form ref="copyForm" :model="copyForm">
        <el-form-item label="所属科目:" prop="courseId">
          <el-cascader
            clearable
            :show-all-levels="false"
            v-model="copyForm.courseId"
            :props="subjectTreeProps"
            placeholder="请输入具体课程"
            :options="subjectTreeList"
            @change="subjectSearchChange"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="copyMoreCancel('copyForm')">取 消</el-button>
        <el-button type="primary" @click="copyMore">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Import from "../conmom/import";
import tree from "../conmom/tree";
export default {
  components: { Import, tree },

  data () {
    return {
      id:'', // 选择了课程对应的id 
      copyDialog: false,
      videoDialog: false,
      knowledgeLoading: false,
      knowledgeVisible: false,
      knowledgeAddVisible: false,
      copyForm: {
        courseId: '',
        courseIdByNew: ''
      },
      knowledgeForm: {
        name: "",
        rate: null,
        hard: null,
        sort: ""
      },
      knowledgeFormRules: {
        name: [
          {
            required: true,
            message: "请输入考点名称",
            trigger: "blur"
          }
        ],

        rate: [
          {
            required: true,
            message: "请输入考频",
            trigger: "blur"
          },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入考频"
          }
        ],
        hard: [
          {
            required: true,
            message: "请输入难度",
            trigger: "blur"
          },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入难度"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      knowledgeList: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      valueData: "",
      valueData1: [],
      videoList: [],
      videoRows: [],
      addvideoList: [],
      addVideoForm: {
        chapterId: "",
        videoInfoIds: ""
      },
      addFile: {
        attachment: "",
        attachmentName: "",
        id: ""
      },
      downType: true,
      addFileRules: {
        attachment: [
          {
            required: true,
            message: "请输入选择要上传的文件",
            trigger: "blur"
          }
        ],
        attachmentName: [
          {
            required: true,
            message: "请输入文件名称",
            trigger: "blur"
          }
        ]
      },
      chapterId: "",
      videoLoadData: {},
      fileLoadData: {},
      webLoading: false,
      webLoading1: false,
      webLoading2: false,
      addVideoVisible: false,
      importVisible: false,
      addFileVisible: false,

      addState: 0,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeList: [], //课程，
      chapterList: [], //科目，
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        subjectCourseId: ""
      },
      addForm: {
        pid: "",
        courseId: "",
        state: "1",
        pay: "1"
      },
      courseIdsss: "",
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入pid",
            trigger: "blur"
          }
        ],
        pid: [
          {
            required: true,
            message: "请输入pid",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "pid格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入章节名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "章节名称长度在1到255个字"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        pay: [
          {
            required: true,
            message: "请输入是否付费",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否付费格式不正确"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ]
      },
      editForm: {
        pid: "",
        name: "",
        sort: "",
        state: "",
        pay: "",
        price: "",
        courseId: "",
        remark: ""
      },
      editFormRules: {
        pid: [
          {
            required: true,
            message: "请输入pid",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "pid格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入章节名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "章节名称长度在1到255个字"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        pay: [
          {
            required: true,
            message: "请输入是否付费",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否付费格式不正确"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        remark: [
          {
            min: 1,
            max: 255,
            message: "备注长度在1到255个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      videoPath: "",
      filePath: "",
      ids: [],
      videoArr: [],

      fileAction: `${process.env.BASE_URL}/chapter/upload`,
      fileList: [],
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
        url2: process.env.BASE_URL + "/question/importQuestionsByChapter"
      },
      loading: false,
      filter: "",
      knowledgeChapterId: "",
      treeData: [],
      defaultProps: {
        children: "list",
        label: "name"
      }
    };
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    }
  },
  methods: {
    copyMoreCancel (copyForm) {
      this.$refs[copyForm].resetFields();
      this.copyDialog = false
    },
    // 批量复制
    copyMore () {
      console.log(res, 777777);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      this.copyDialog = false
      this.api.chapter.copyMore(this.copyForm).then(res => {
        console.log(res, 'res');
      })
      this.pageList()

    },
    subjectSearchChange (val) {
      if (val) {
        if (val.length > 0) {
          this.copyForm.courseId = val[val.length - 1];
          console.log(this.copyForm.courseId, 789789);
        } else {
          this.copyForm.courseId = "";
        }
      }
    },
    deleteChapterKnowledge (id) {
      this.$confirm(
        "将会同时删除此考点下的试题关联，是否确认删除？",
        "系统消息",
        {
          type: "warning"
        }
      )
        .then(() => {
          this.api.chapter
            .deleteChapterKnowledge({ id: id })
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.knowledgeAddVisible = false;
                this.chapterKnowledgeList(this.knowledgeChapterId);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    updateChapterKnowledge () {
      this.$refs.knowledgeForm.validate(valid => {
        console.log("valid", valid);
        if (valid) {
          this.$refs.knowledgeForm.validate(valid => {
            this.api.chapter
              .updateChapterKnowledge(this.knowledgeForm)
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.knowledgeAddVisible = false;
                  this.chapterKnowledgeList(this.knowledgeChapterId);
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          });
        }
      });
    },
    addChapterKnowledge () {
      if (this.knowledgeForm.id) {
        this.updateChapterKnowledge();
      } else {
        this.knowledgeForm.chapterId = this.knowledgeChapterId;
        this.$refs.knowledgeForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.api.chapter
              .addChapterKnowledge(this.knowledgeForm)
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.knowledgeAddVisible = false;
                  this.chapterKnowledgeList(this.knowledgeChapterId);
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        });
      }
    },
    chapterKnowledgeList (id) {
      this.api.chapter
        .chapterKnowledgeList({
          chapterId: id
        })
        .then(result => {
          this.knowledgeLoading = false;
          if (result.success) {
            this.knowledgeList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openknowledgeVisible (id) {
      console.log(id);
      this.knowledgeVisible = true;
      this.knowledgeLoading = true;
      this.knowledgeChapterId = id;
      this.chapterKnowledgeList(id);
    },
    openknowledgeAddVisible (row) {
      if (row.chapterId) {
        this.knowledgeForm = row;
      }
      this.knowledgeAddVisible = true;
    },
    closeDialog () {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    addConcat () {
      this.videoArr.forEach((item, index) => {
        let style = true;
        this.videoRows.forEach((items, indexs) => {
          if (item.id == items.id) {
            style = false;
          }
        });
        if (style) {
          this.videoRows.push(item);
        }
      });
    },
    deleteVideo (id) {
      this.videoRows.forEach((item, index) => {
        if (id == item.id) {
          this.videoRows.splice(index, 1);
        }
      });
    },
    DownLoadFile () {
      window.open(this.addFile.attachment);
    },
    goExamView (row) {
      this.knowledgeVisible = false;
      this.$router.push({
        path: "/chapterView",
        query: {
          chapterId: row.chapterId,
          knowledgeId: row.id
        }
      });
    },
    goQuestion (id) {
      this.$router.push({
        path: "/chapterView",
        query: {
          chapterId: id
        }
      });
    },
    showmessahe (data) {
      this.importVisible = data;
      this.pageList();
    },
    subjectChange (val) {
      if (val) {
        if (val.length > 0) {
          this.addForm.courseId = val[val.length - 1];
        } else {
          this.addForm.courseId = "";
        }
      }
    },
    //   获取下拉
    getSubjectTreeList () {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    getChapterList2 (row) {
      // 获取试题类型
      this.api.chapter
        .getFatherChapterList({
          courseId: row.courseId
        })
        .then(result => {
          this.chapterList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getChapterList (row) {
      // 获取试题类型
      this.api.chapter
        .getFatherChapterList({
          courseId: row.courseId
        })
        .then(result => {
          this.chapterList = result.data;
          console.log("this.chapterList", this.chapterList);
          this.addState = 2;
          // console.log("this.addForm.pid", this.addForm.pid);
          this.setPid(row);
          this.addFormVisible = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    setPid (row) { },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getChapter () {
      // this.api.chapter
      //   .getChapter({
      //     id: this.editForm.id
      //   })
      //   .then(result => {
      //     this.editForm = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    listChange (val) {
      this.api.videoInfo
        .getVideoInfoList({
          videoCourseId: val
        })
        .then(result => {
          if (result.success) {
            this.addvideoList = result.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addlistChange (val) {
      this.videoArr = [];
      val.forEach(item => {
        this.addvideoList.forEach(items => {
          if (item == items.id) {
            this.videoArr.push(items);
          }
        });
      });
      console.log(this.videoArr);
    },
    openVideo (row) {
      this.webLoading1 = true;
      this.addVideoForm.chapterId = row.id;
      this.api.chapter
        .chapterVideoList({
          chapterId: row.id
        })
        .then(result => {
          this.webLoading1 = false;
          if (result.success) {
            this.videoRows = result.data;
            // this.videoRows.forEach(item => {
            //   this.valueData1.push(item.id);
            // });
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.api.videoCourse
        .getVideoCourseList({
          courseId: row.courseId
        })
        .then(result => {
          if (result.success) {
            this.videoList = result.data;
            this.addVideoVisible = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList () {
      this.webLoading = true;
      this.searchForm.pageSize = this.page.pageSize;

      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.chapter
        .pageList(this.searchForm)
        .then(result => {
          this.webLoading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },

    updateChapter () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.editForm.courseId instanceof Array) {
            if (this.editForm.courseId.length == 3) {
              this.editForm.courseId = this.editForm.courseId[2];
            }
          }
          this.api.chapter
            .updateChapter(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    changeId (data) {
      console.log(456,data);
      this.id=data[0].id
      // console.log(this.copyForm.courseIdByNew, 456);
      this.copyForm.courseIdByNew = data[0].id;
      this.searchForm.subjectCourseId = data[0].id;
      this.addForm.parentId = data[0].id;
      this.editForm.parentId = data[0].id;
      if (!data[0].disabled) {
        if (data[2] == 3) {
          this.pageList();
        }
      }
    },
    changeCourseId (data) {
      this.addForm.courseId = data.id;
      this.addState = 1;
      this.courseIdsss = data.id;
      console.log(this.addForm.courseId);
      this.addFormVisible = true;
    },
    addChapter () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // this.addForm.courseId = this.courseIdsss
          //   ? this.courseIdsss
          //   : this.addForm.courseId;
          this.api.chapter
            .addChapter(this.addForm)
            .then(result => {
              this.addFormVisible = false;
              this.courseIdsss = "";
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    chapterAttachment () {
      if (!this.addFile.attachment) {
        return this.$message.error("请选择要上传的文件！！！");
      }
      this.$refs.addFileForm.validate(valid => {
        if (valid) {
          this.api.chapter
            .chapterAttachment(this.addFile)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.addFileVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteChapter (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.chapter
            .deleteChapter([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteChapter () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.chapter
            .deleteChapter(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      if (!response.success) {
        return this.$message.error(response.message);
      }
      this.importForm = response.data;
    },
    videoHandleSuccess (response, file, fileList, $event) {
      this.addVideoForm.videoInfoIds = response.data;
    },
    updateChapterVideo () {
      let arr = [];
      this.videoRows.forEach(item => {
        arr.push(item.id);
      });
      this.addVideoForm.videoInfoIds = arr;
      this.api.chapter
        .updateChapterVideo(this.addVideoForm)
        .then(result => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.addVideoVisible = false;
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    videoBeforeImgUpload (file) {
      //判断是否绑定视频
      if (this.videoLoadData) {
      }
      const isVideo = file.type.indexOf("video") > -1;
      if (!isVideo) {
        this.$message.error("上传文件必须是视频哦!");
      }

      return isVideo;
    },
    fileBeforeFileUpload (file) {
      console.log(1827,this.id);
      if(this.id=='') return
      // console.log(this.id);
      if (this.fileLoadData) {
      }
      const isExcel =
        file.name.indexOf("xlsx") > -1 || file.name.indexOf("xls") > -1;
      if (!isExcel) {
        this.$message.error("上传文件必须是xlsx哦!");
      }
      return isExcel;
    },
    fileBeforeImgUpload (file) {
      // if (this.fileLoadData) {
      // }
      // const isExcel = file.type.indexOf("excel") > -1;
      // if (!isExcel) {
      //   this.$message.error("上传文件必须是excel哦!");
      // }
      // return isExcel;
    },
    fileHandleSuccess (response, file, fileList, $event) {
      this.addFile.attachment = response.data;
    },
    fileLoadSuccess (response, file, fileList, $event) {
      if (response.success) {
        this.$message.success(response.message);
        this.pageList();
      } else {
        this.$message.error(response.message);
      }
      this.webLoading2 = false;
    },
    fileError (response, file, fileList, $event) {
      this.webLoading2 = false;
      if(this.id==''){
        this.$message.error('请先选择左侧课程')
        return
      }
      this.$message.error("导入失败");
    },
    fileFprogress () {
      this.webLoading2 = true;
    },

    exportExcel () {
      this.loading = true;
      this.api.chapter
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData () {
      this.api.chapter
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // getChapterTree() {
    //   this.api.chapter
    //     .getChapterTree({})
    //     .then(result => {
    //       this.treeData = result.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    nodeFilter (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    treeFilter: function () {
      this.$refs.tree.filter(this.filter);
    },
    downloadFile () {
      // window.open(
      //   "http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15717971761918563706065.xls+"&tables="+试题批量录入模板"
      // );
      // const url =
      //   "http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15717971761918563706065.xls";
      const url = "./static/file/章节批量导入试题模板.xlsx";
      window.open(url);
      // const link = document.createElement("a");
      // link.style.display = "none";
      // link.href = url;
      // link.setAttribute("download", "试题批量录入模板");
      // document.body.appendChild(link);
      // link.click();
    },
    handleNodeClick (data) {
      this.searchForm.subjectCourseId = data.id;
      this.addForm.parentId = data.id;
      this.editForm.parentId = data.id;
      if (!data.disabled) {
        this.pageList();
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.path == "/chapterView") {
        vm.pageList();
      }
    });
  },
  watch: {
    knowledgeVisible (val) {
      if (!val) {
        this.knowledgeChapterId = "";
        this.pageList();
      }
    },
    knowledgeAddVisible (val) {
      if (!val) {
        this.knowledgeForm = {
          name: "",
          rate: null,
          hard: null,
          sort: ""
        };
      }
    },
    addVideoVisible (val) {
      if (!val) {
        this.valueData = "";
        this.valueData1 = [];
        this.videoList = [];
        this.videoRows = [];
        this.addvideoList = [];
        this.addVideoForm = {
          chapterId: "",
          videoInfoIds: ""
        };
      }
    },
    addFileVisible (val) {
      if (!val) {
        this.addFile = {
          attachment: "",
          attachmentName: "",
          id: ""
        };
      }
    },
    "addFile.attachment" (val) {
      if (val) {
        this.downType = false;
      } else {
        this.downType = true;
      }
    },
    "addForm.pay" (val) {
      if (val == -1) {
        this.addFormRules.price = [
          {
            required: false,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ];
        this.addForm.price = 0;
        console.log(1111, this.addForm.price);
      } else {
        this.addFormRules.price = [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ];
      }
    },
    "editForm.pay" (val) {
      if (val == -1) {
        this.editFormRules.price = [
          {
            required: false,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ];
        this.editForm.price = 0;
        console.log(1111, this.editForm.price);
      } else {
        this.editFormRules.price = [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ];
      }
    },
    addState (val) {
      if (val == 1) {
        this.addForm = {
          courseId: this.addForm.courseId,
          pid: 0,
          name: "",
          sort: "",
          pay: 1,
          state: 1
        };
      } else if (val == 2) {
        this.addForm = {
          pid: this.addForm.pid,
          name: "",
          sort: "",
          state: 1,
          pay: "",
          price: "",
          courseId: "",
          remark: ""
        };
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getChapter();
      }
      this.editForm.state = Number(this.editForm.state);
    },
    filter: function (newVal) {
      this.treeFilter();
    }
  },
  mounted () {
    // this.getChapterTree();
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>
<style >
.chapter .el-rate__icon {
  /* display: flex !important;
  align-items: center !important; */
  line-height: 32px !important;
}
.knowledgeVisible .el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding-top: 0px !important;
}
</style>
<style lang="less" scoped>
.chapter {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-card__body {
  height: 100% !important;
}
.view-video {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .view-item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.view-file {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  .aaaaa {
    position: absolute;
    left: 100px;
    top: 0px;
  }
}
.re {
  color: rgb(255, 100, 107);
}
.gr {
  color: rgb(36, 210, 181);
}
.hei {
  color: rgb(162, 170, 188);
}
.name-algin {
  display: flex;
  flex-direction: row;
  align-items: center;
  i {
    margin-left: 4px;
  }
}
.title-add {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  color: #455a64;
  div {
    font-size: 14px;
    i {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
.operationGroups {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #eeeeee;
}
.operationGroupsx {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #eeeeee;
}
.operationGroupsx span {
  color: #37aefe;
  width: 50%;
}
.operationGroups span {
  color: #37aefe;
  width: 33%;
}
</style>



// WEBPACK FOOTER //
// src/components/chapter/index_tree.vue